module.exports = __webpack_public_path__ + "img/examples-en-6.a8a73f50.jpg";